/* Pagination Helprs */
import React from "react";
import { FormattedMessage } from "react-intl";

export const getPagesCount = (totalSize, sizePerPage) => {
  return Math.ceil(totalSize / sizePerPage);
};

export const getPages = (page, pagesCount, paginationSize) => {
  const result = [];
  if (!page) {
    return result;
  }

  if (pagesCount === 1) {
    result.push(1);
    return result;
  }

  if (pagesCount < page) {
    return result;
  }

  if (pagesCount < paginationSize + 1) {
    for (let i = 1; i < pagesCount + 1; i++) {
      result.push(i);
    }
    return result;
  }

  if (page === 1) {
    for (let i = 1; i < paginationSize + 1; i++) {
      if (i < pagesCount) {
        result.push(i);
      }
    }
    return result;
  }

  if (page === pagesCount) {
    for (let i = pagesCount - paginationSize + 1; i <= pagesCount; i++) {
      if (i <= pagesCount) {
        result.push(i);
      }
    }
    return result;
  }

  const shiftCount = Math.floor(paginationSize / 2);
  if (shiftCount < 1) {
    result.push(page);
    return result;
  }

  //
  if (page < shiftCount + 2) {
    for (let i = 1; i < paginationSize + 1; i++) {
      result.push(i);
    }
    return result;
  }

  if (pagesCount - page < shiftCount + 2) {
    for (let i = pagesCount - paginationSize; i < pagesCount + 1; i++) {
      result.push(i);
    }
    return result;
  }

  for (let i = page - shiftCount; i < page; i++) {
    if (i > 0) {
      result.push(i);
    }
  }
  result.push(page);
  for (let i = page + 1; i < page + shiftCount + 1; i++) {
    if (i <= pagesCount) {
      result.push(i);
    }
  }

  return result;
};

export function getHandlerTableChange(setQueryParams, setEditableList) {

  return (type, { page, sizePerPage, sortField, sortOrder, data, cellEdit }) => {
    if (type === "cellEdit") {
      data.forEach(element => {
        if (element.id === cellEdit.rowId) {
          element[cellEdit.dataField] = cellEdit.newValue
        }
      });
      setEditableList([...data])
    }
    else {
      if (sortField == "groupTitle") sortField = "groupId"
      else if (sortField == "dormTitle") sortField = "dormId"
      else if (sortField == "blockTitle") sortField = "blockId"
      else if (sortField == "roomTitle") sortField = "roomId"
      else if (sortField == "collageTitle") sortField = "collageId"
      else if (sortField == "semesterTitle") sortField = "semesterId"
      else if (sortField == "yearTitle") sortField = "yearId"
      else if (sortField == "termTitle") sortField = "termId"
      else if (sortField == "enterTermTitle") sortField = "enterTermId"
      else if (sortField == "gradeTitle") sortField = "gradeId"
      else if (sortField == "groupTitle") sortField = "groupId"
      else if (sortField == "subGroupTitle") sortField = "subGroupId"
      else if (sortField == "roleTitle") sortField = "roleId"
      else if (sortField == "workUnitTitle") sortField = "workUnitId"
      else if (sortField == "onRoleTitle") sortField = "onRoleId"
      else if (sortField == "menuDescription") sortField = "menuId"
      else if (sortField == "menuTitle") sortField = "menuId"
      else if (sortField == "provinceTitle") sortField = "provinceId"
      else if (sortField == "userFullName") sortField = "userId"
      else if (sortField == "salonTitle") sortField = "salonId"
      else if (sortField == "sportTitle") sortField = "sportId"
      else if (sortField == "sansTimeTitle") sortField = "sansTimeId"
      else if (sortField == "sansCategoryTitle") sortField = "sansCategoryId"
      else if (sortField == "teacherName") sortField = "teacherId"

      const pageNumber = page || 1;
      setQueryParams((prev) =>
        type === "sort"
          ? { ...prev, sortOrder, sortField, orderClause: `${sortField} ${sortOrder}` }
          : type === "pagination"
            ? { ...prev, pageNumber, pageSize: sizePerPage, takeCount: sizePerPage, skipCount: (pageNumber - 1) * sizePerPage }
            : prev
      );

    }
  };

}

export function getHandlerReportTableChange(setQueryParams, setChangeFilter) {

  return (type, { page, sizePerPage, sortField, sortOrder, data, cellEdit }) => {
    if (sortField == "groupTitle") sortField = "groupId"
    else if (sortField == "dormTitle") sortField = "dormId"
    else if (sortField == "blockTitle") sortField = "blockId"
    else if (sortField == "roomTitle") sortField = "roomId"
    else if (sortField == "collageTitle") sortField = "collageId"
    else if (sortField == "semesterTitle") sortField = "semesterId"
    else if (sortField == "yearTitle") sortField = "yearId"
    else if (sortField == "termTitle") sortField = "termId"
    else if (sortField == "enterTermTitle") sortField = "enterTermId"
    else if (sortField == "gradeTitle") sortField = "gradeId"
    else if (sortField == "groupTitle") sortField = "groupId"
    else if (sortField == "subGroupTitle") sortField = "subGroupId"
    else if (sortField == "roleTitle") sortField = "roleId"
    else if (sortField == "workUnitTitle") sortField = "workUnitId"
    else if (sortField == "onRoleTitle") sortField = "onRoleId"
    else if (sortField == "menuDescription") sortField = "menuId"
    else if (sortField == "menuTitle") sortField = "menuId"
    else if (sortField == "provinceTitle") sortField = "provinceId"
    else if (sortField == "userFullName") sortField = "userId"
    else if (sortField == "salonTitle") sortField = "salonId"
    else if (sortField == "sportTitle") sortField = "sportId"
    else if (sortField == "sansTimeTitle") sortField = "sansTimeId"
    else if (sortField == "sansCategoryTitle") sortField = "sansCategoryId"
    else if (sortField == "teacherName") sortField = "teacherId"

    const pageNumber = page || 1;
    setQueryParams((prev) =>
      type === "sort"
        ? { ...prev, sortOrder, sortField, orderClause: `${sortField} ${sortOrder}` }
        : type === "pagination"
          ? { ...prev, pageNumber, pageSize: sizePerPage, takeCount: sizePerPage, skipCount: (pageNumber - 1) * sizePerPage }
          : prev
    );
    if (setChangeFilter) setChangeFilter(true)
  };

}

// export function getHandlerTableChange(setQueryParams, setEditableList) {

//   return (type, { page, sizePerPage, sortField, sortOrder, data, cellEdit }) => {

//     if (type === "cellEdit") {
//       data.forEach(element => {
//         if (element.id === cellEdit.rowId) {
//           element[cellEdit.dataField] = cellEdit.newValue
//         }
//       });

//       console.log("data2")
//       console.log(data)
//       setEditableList([...data])
//     }
//     else {
//       if (sortField == "groupTitle") sortField = "groupId"
//       else if (sortField == "dormTitle") sortField = "dormId"
//       else if (sortField == "blockTitle") sortField = "blockId"
//       else if (sortField == "roomTitle") sortField = "roomId"
//       else if (sortField == "collageTitle") sortField = "collageId"
//       else if (sortField == "semesterTitle") sortField = "semesterId"
//       else if (sortField == "yearTitle") sortField = "yearId"
//       else if (sortField == "termTitle") sortField = "termId"
//       else if (sortField == "enterTermTitle") sortField = "enterTermId"
//       else if (sortField == "gradeTitle") sortField = "gradeId"
//       else if (sortField == "groupTitle") sortField = "groupId"
//       else if (sortField == "subGroupTitle") sortField = "subGroupId"

//       const pageNumber = page || 1;
//       setQueryParams((prev) =>
//         type === "sort"
//           ? { ...prev, sortOrder, sortField, orderClause: `${sortField} ${sortOrder}` }
//           : type === "pagination"
//             ? { ...prev, pageNumber, pageSize: sizePerPage, takeCount: sizePerPage, skipCount: (pageNumber - 1) * sizePerPage }
//             : prev
//       );
//     }
//   };

// }

export function PleaseWaitMessage({ entities }) {
  return <>{entities === null && <div><FormattedMessage id="WAIT.MESSAGE" /></div>}</>;
}

export function NoRecordsFoundMessage({ entities }) {
  const customersList = entities === null ? [] : entities;
  return (
    <>
      {customersList.length === 0 && entities !== null && (
        <div><FormattedMessage id="PAGINATION.NO.RECORD" /></div>
      )}
    </>
  );
}
